import axios from 'axios';

const instance = axios.create();

instance.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		console.log('ERROR IN AXIOS', error);
		if (error.response.status === 401) {
			// TODO: This needs to check whether the call was made to the authorize/verify endpoint or a subsequent endpoint.
			//
			// TODO: how to use this to log the user out.
			console.log('MY 401 CAPTURE', error);

			if (error.response.data.message === 'Auth failed') {
				// eslint-disable-next-line
				localStorage.clear();
				// @TODO: Put this back if auth fails. // window.location.replace(`${get('host')}/login`);
			}
		}
		return error.response;
	}
);

const setAuth = (token) => {
	instance.defaults.headers.common.Authorization = token;
};

const getAuth = () => {
	return instance.defaults.headers.common.Authorization;
};

export default instance;

export { getAuth, setAuth };
